const CONTEXT_TOKEN = /^\{[A-Za-z_][A-Za-z0-9_]*\}$/;

export function serializeRuntimePropertyValue(value, definition) {
    if (!definition) return null;
    if (definition.type === 'bool') return value === true || value === 1 || value === '1' ? '1' : '0';
    if (['int', 'float', 'number'].includes(definition.type)) {
        if (CONTEXT_TOKEN.test(String(value))) return String(value);
        const number = Number(value);
        if (!Number.isFinite(number)) return null;
        if (definition.min !== undefined && number < definition.min) return null;
        if (definition.max !== undefined && number > definition.max) return null;
        return String(number);
    }
    if (definition.type === 'enum') {
        return (definition.values ?? []).some(option => String(option?.value ?? option) === String(value))
            ? String(value) : null;
    }
    if (definition.type === 'color') {
        const color = String(value ?? '');
        return /^#[0-9a-fA-F]{6}([0-9a-fA-F]{2})?$/.test(color) ? color : null;
    }
    if (['string', 'resource'].includes(definition.type)) return String(value ?? '');
    return null;
}

export function parseRuntimePropertyValue(value, definition) {
    if (!definition) return null;
    if (definition.type === 'bool') {
        if (value === '1' || value === 'true') return true;
        if (value === '0' || value === 'false') return false;
        return null;
    }
    if (['int', 'float', 'number'].includes(definition.type)) {
        if (CONTEXT_TOKEN.test(value)) return value;
        const number = Number(value);
        if (!Number.isFinite(number)) return null;
        if (definition.min !== undefined && number < definition.min) return null;
        if (definition.max !== undefined && number > definition.max) return null;
        return number;
    }
    if (definition.type === 'enum') {
        const option = (definition.values ?? []).find(item => String(item?.value ?? item) === value);
        return option === undefined ? null : (option?.value ?? option);
    }
    if (definition.type === 'color' && !/^#[0-9a-fA-F]{6}([0-9a-fA-F]{2})?$/.test(value)) return null;
    if (['string', 'color', 'resource'].includes(definition.type)) return value;
    return null;
}
